import type { CodeSchemaType } from '@vedalib/editor/lib/brand'
import type { CodeElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { LanguagesEnum } from '@vedalib/editor/lib/elements/elements/Code/constants'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import type { FCDemoType } from '../../elements.types'
import Element from './CodeElement'

const DEMO_VALUE: CodeElementValue = {
  code: t('elements.code.value.code'),
  language: LanguagesEnum.html,
  showCopyButton: true,
}

const CodeDemo: FCDemoType<CodeSchemaType> = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.code.type}-demo`,
        type: CONFIG_ELEMENTS.code.type,
        value: DEMO_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default CodeDemo
